module.exports = __webpack_public_path__ + "static/courses-7c43ea74ded8dd318260562892a4c036.jpg";